import { styles } from '../../vehicle-card.styles';
import { myAdsTestId } from '../../../../utils';
import type { TCardPriceConfig } from '../../vehicle-card.types';

const CardPrice = ({ adId, formattedPrice }: TCardPriceConfig) => {
	return (
		<p className={styles.price} data-testid={myAdsTestId.cardPrice(adId)}>
			{formattedPrice}
		</p>
	);
};

CardPrice.displayName = 'CardPrice';

export { CardPrice };
